import { RewardPoints } from '@capsicum/common';
import { Image, Snackbar } from '@capsicum/common-web';
import { type RewardPointsSnackbarProps, useRewardPointsSnackbar } from '@capsicum/socios-core';
import { useTheme } from 'styled-components';

/**
 * This component returns the Reward Points Snackbar component
 * @param {number} props.amount The reward points amount
 * @param {string} props.behaviorId The behavior ID
 * @param {string} props.testID The test ID
 * @returns {JSX.Element} This component
 */
export const RewardPointsSnackbar = ({ amount, behaviorId, notificationId, testID }: RewardPointsSnackbarProps) => {
	const { intlText } = useRewardPointsSnackbar(amount, behaviorId);
	const { colors } = useTheme();
	const style = { backgroundColor: colors.backgrounds.info.subtle };
	const image = <Image alt="Reward Points Image" height={24} src={RewardPoints} width={32} />;

	return (
		<Snackbar
			description={intlText.description}
			leftContent={image}
			notificationId={notificationId}
			style={style}
			testID={testID}
			title={intlText.title}
		/>
	);
};
